import { _ } from "../../../polyglot/polyglot.js";
import { formatAsLongMonthAndYear } from "../../../helpers/date-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import MonthPickerWidget from "../MonthPickerWidget/MonthPickerWidget.js";
import Timespan from "../../../../models/period/Timespan.js";

/**
 * `ActivePeriodPickerWidget` is a section of `selectDataStepWidget`
 * to choose the last active month.
 */
export default class ActivePeriodPickerWidget extends Widget {
	constructor() {
		super(...arguments);

		this._selection = null;
		this._lastTransactionDate = null;

		this._activeMonthPicker = new MonthPickerWidget();

		this._activeMonthPicker.onDateChanged.register((date) => {
			this._selection = date;
		});
	}

	setSelectableMonths({ transactionTimespan, fiscalYearEnd }) {
		this._lastTransactionDate = transactionTimespan.getEnd();
		this._selection = this._lastTransactionDate;

		this._activeMonthPicker.withUpdate(() => {
			this._activeMonthPicker.setRange(
				new Timespan({
					start: transactionTimespan.getStart(),
					end: fiscalYearEnd,
				}),
			);

			this._activeMonthPicker.setSelectedDate(this._selection);
		});

		this.update();
	}

	getSelection() {
		return this._selection;
	}

	renderContentOn(html) {
		html.div(
			{
				klass: "form-group filter-data-to",
				"data-test": "active-period-picker",
			},
			html.label(
				{ klass: "control-label col-sm-4" },
				_("Last active month"),
			),
			html.div(
				{ klass: "col-sm-8 check-group" },
				html
					.label(
						html.input({
							klass: "form-control",
							type: "radio",
							name: "active-month",
							value: "latest",
							checked: "checked",
						}),
						_("Latest month ({month})", {
							month: formatAsLongMonthAndYear(
								this._lastTransactionDate,
							),
						}),
					)
					.on("change", this._setAllActive.bind(this)),
				html
					.label(
						html.input({
							klass: "form-control",
							type: "radio",
							name: "active-month",
							value: "inactive",
						}),
						_("No active period"),
					)
					.on("change", this._setAllInactive.bind(this)),
				html.label(
					{ change: this._setCustom.bind(this) },
					html.input({
						klass: "form-control",
						type: "radio",
						name: "active-month",
					}),
					_("Choose a month"),
				),
				html.div(
					{ klass: "custom-range", "data-test": "custom-range" },
					this._activeMonthPicker,
				),
			),
		);
	}

	_setAllActive() {
		this._hideCustom();
		this._selection = this._lastTransactionDate;
	}

	_setAllInactive() {
		this._hideCustom();
		this._selection = null;
	}

	_setCustom() {
		this.asJQuery().find(".custom-range").show();
		this._selection = this._activeMonthPicker.getSelectedDate();
	}

	_hideCustom() {
		this.asJQuery().find(".custom-range").hide();
	}
}
